import script from "./PackageView.vue?vue&type=script&setup=true&lang=js"
export * from "./PackageView.vue?vue&type=script&setup=true&lang=js"

import "./PackageView.vue?vue&type=style&index=0&id=1fd06007&scoped=true&lang=css"
import "./PackageView.vue?vue&type=style&index=1&id=1fd06007&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fd06007"]])

export default __exports__